var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('Logo'),_c('div',{staticClass:"header-main"}),_c('UserOneIDAuth')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }